import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M4.471 12.845a.75.75 0 0 1 .21-.403l8.63-8.631a4.638 4.638 0 0 1 6.56 6.56L11.24 19a.75.75 0 0 1-.403.21l-6.643 1.144a.75.75 0 0 1-.867-.867l1.144-6.643Zm1.233 1.682 3.451 3.451-4.17.718.719-4.17Zm5.005 2.884 6.727-6.726-4.438-4.439-6.727 6.727 4.438 4.438Zm3.35-12.225 4.437 4.438.315-.314a3.138 3.138 0 1 0-4.439-4.438l-.314.314Z"
      clipRule="evenodd"
    />
    <path fill="#F7A600" d="M6 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
  </svg>
);
export default SvgTwoColorEdit;
